import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import StatusCell from '../../../components/Badge/StatusCell';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import StackSquareIcon from '../../../components/Icons/StackSquareIcon';
import PageLayout from '../../../components/Layout/PageLayout';
import { Modal } from '../../../components/Modal/Modal';
import ReportInformationModal from '../../../components/Modal/ModalActions/ReportInformationModal/ReportInformationModal';
import Page from '../../../components/Page/Page';
import Table from '../../../components/Table/Table';
import ActionRow from '../../../components/Table/TableAccessories/ActionRow';
import useGetDriverReportAndConflictDetails from '../../../hooks/dashboard/companyInsight/useGetDriverReportAndConflictDetails';
import {
  COMPANY_INSIGHTS,
  COMPANY_INSIGHTS_DRIVER_LIST,
  COMPANY_INSIGHTS_DRIVER_LIST_PAST_COMPANIES,
  COMPANY_INSIGHTS_DRIVER_LIST_PAST_COMPANIES_CONFLICT_DETAILS,
} from '../../../routes/routeConstants';

const DriverHistoryPastCompanies = () => {
  const navigate = useNavigate();
  const [pathArr, setPathArr] = useState<Record<string, string>[]>([]);

  const {
    getDriverReportAndConflictDetails,
    loading,
    showSuccessModal,
    setShowSuccessModal,
    driverReportAndConflictDetailsData,
  } = useGetDriverReportAndConflictDetails();

  const handleRowActionCall = async (data: any) => {
    await getDriverReportAndConflictDetails(data);
  };

  if (driverReportAndConflictDetailsData) {
    navigate(
      `/${COMPANY_INSIGHTS_DRIVER_LIST_PAST_COMPANIES_CONFLICT_DETAILS}`,
    );
  }

  useEffect(() => {
    setPathArr(() => [
      {
        name: `Driver History`,
        link: `/${COMPANY_INSIGHTS}`,
      },
      {
        name: `Pacific Stereo`,
        link: `/${COMPANY_INSIGHTS_DRIVER_LIST}`,
      },
      {
        name: `Jude Nwaeze`,
        link: `/${COMPANY_INSIGHTS_DRIVER_LIST_PAST_COMPANIES}`,
      },
    ]);
    // eslint-disable-next-line
  }, []);

  return (
    <Page title='Logirate | Driver History Past Companies'>
      <PageLayout>
        <BreadCrumbs pathData={pathArr as any} />
        <Container>
          <Table
            // border
            tableTitle='PAST COMPANIES '
            tableFilterBoxFeatures={{
              showSearchBox: true,
              searchBoxPlaceholder: 'Search Company Name',
            }}
            tableHeader={{
              'Company Name': 'username',
              'Employment type': 'employmentType',
              'Time at Company': 'username',
              'Employment Status': 'employmentStatus',
              'Hiring Conflicts': 'phoneNumber',
              'Accident Reports': 'email',
              'Theft Reports': 'email',
            }}
            tableDataSourceUrl='authentication-service/ba/v1/company/users/warehouse'
            cellsCustomComp={{
              employmentType: <StatusCell statusKey='employmentType' />,
              employmentStatus: (
                <StatusCell statusKey='employmentStatus' hasDot />
              ),
            }}
            moreOptionsComponents={[
              <ActionRow
                key='View details'
                label='View details'
                width='174px'
                icon={loading ? <StackSquareIcon /> : <StackSquareIcon />}
                actionFn={async (data: any) => {
                  handleRowActionCall(data);
                }}
              />,
            ]}
            // mobileCellComp={<UserProfileManagementCell />}
            // showPaginationControl={false}
          />
        </Container>
        <Modal showModal={showSuccessModal} setShowModal={setShowSuccessModal}>
          <ReportInformationModal
            label='Report Information'
            description='There are currently no hiring conflicts, accident reports, or theft
        reports associated with this record.'
          />
        </Modal>
      </PageLayout>
    </Page>
  );
};

export default DriverHistoryPastCompanies;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
